import { FilterContentFieldDataTypes } from '../../../filter/constants';
import { Filter } from '../../../filter/interface';
import { PIPELINE_FILTER_STATUSES } from '../../../pipelines/constants/pipeline-status';

export const CONNECTED_PIPELINE_FILTERS: Filter[] = [
  {
    title: 'Status',
    filterKey: 'status',
    filterType: FilterContentFieldDataTypes.LIST,
    filterContentProps: {
      multiple: true,
      selectMode: true,
      options: PIPELINE_FILTER_STATUSES
    }
  }
];
